<template>
  <v-container id="clientes" tag="section">
    <base-v-component heading="Backups del sistema " />
    <base-material-card color="indigo" icon="mdi-currency-eur" inline class="px-5 py-3">
      <v-toolbar flat color="white">
        <v-btn color="success" dark class="mb-2" @click="goAdd()">Crear Copia de seguridad</v-btn>
        <v-spacer />
        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="backups"
        :loading="loading"
        sort-by="fecha"
        sort-desc
        disable-pagination
      >
        <template v-slot:item.acciones="{ item }">
          <v-spacer></v-spacer>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="info"
                min-width="0"
                v-on="on"
                small
                @click="restore(item)"
              >
                <v-icon small>mdi-backup-restore</v-icon>
              </v-btn>
            </template>
            <span>Restaurar copia de seguridad</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                @click="eliminarBackup(item)"
                class="px-2 ml-1"
                color="red"
                min-width="0"
                small
                v-on="on"
                :loading="loadingEliminar"
              >
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Eliminar backup</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import { mostrarMoneda, idToTexto, mostrarIdioma } from "@/utils/utils.js";
export default {
  data() {
    return {
      loading: false,
      loadingEliminar: false,
      dialog: false,
      headers: [
        {
          sortable: false,
          text: "#",
          value: "id",
        },
        {
          sortable: false,
          text: "Colecciones",
          value: "colecciones",
        },
        {
          sortable: false,
          text: "Fecha",
          value: "fecha",
        },
        {
          sortable: false,
          text: "Usuario",
          value: "usuario",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
    };
  },
  computed: {
    backups() {
      var bk = this.backupsState;
      var res = [];
      bk.forEach((f) => {
        res.push({
          ...f,
          id: f.id,
          nombre: f.nombre,
          colecciones: f.colecciones,
          fecha: moment(f.fecha.toDate()).format("YYYY-MM-DD HH:mm"),
          usuario: f.usuario,
        });
      });
      console.log(res);
      return res;
    },
    ...mapState({
      idiomas: "idiomas",
      langDefecto: "langDefecto",
      backupsState: (state) => state.backup.backupsArray,
    }),
    langSeleccionado: {
      get() {
        return this.$store.state.langSeleccionado;
      },
      set(v) {
        this.$store.commit("setLangSeleccionado", v);
      },
    },
    subtitulo() {
      return "Listado de Copias de seguridad de todo el sistema";
    },
  },
  watch: {},
  methods: {
    restore(item) {},
    view(item) {
      this.$router.push("/admin/backup/form/" + item.id);
    },
    eliminarBackup(item) {
      let _vm = this;
      var confirm = false;
      this.$confirm("¿Desea eliminar la copia? Esta acción es irreversible", {
        buttonTrueText: "Aceptar",
        buttonFalseText: "No",
        color: "warning",
        icon: "warning",
        width: 350,
      })
        .then((r) => {
          if (r) {
            confirm = true;
            _vm.loadingEliminar = true;
            return this.$store.dispatch("backup/eliminarBackup", item);
          }
        })
        .then(() => {
          if (confirm) {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Copia eliminada",
            });
          }
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "No se ha podido eliminar la copia " + e,
          });
        })
        .finally(() => {
          _vm.loadingEliminar = false;
          _vm.reload();
        });
    },
    goAdd() {
      this.$router.push("/admin/backup/form");
    },
    reload() {
      let _vm = this;
      this.$store
        .dispatch("backup/getBackupsArray")
        .then(() => {})
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "No se han podido cargar las copias " + e,
          });
        });
    },
  },
  mounted() {
    this.reload();
  },
};
</script>

<style>
</style>